import { PillarIcon } from './PillarIcon';

/**
 * author: GreenTurtwig
 * id AD451D24-BA4B-466E-8146-D3FBBDA6E275
 * name pillar
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pillar.svg
 * tags
 */
export const ColumnIcon = PillarIcon;
export default ColumnIcon